import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import {
  FormsModule,
  ReactiveFormsModule,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import * as moment from 'moment';
import * as queryString from 'query-string';
import { ApilistService } from 'src/app/services/apilist.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-payments',
  standalone: true,
  imports: [
    CommonModule, // for ngIf, ngFor, ngStyle
    FormsModule, // for ngModel
    ReactiveFormsModule, // for formGroup, formControlName (if you use reactive forms later)
  ],
  templateUrl: './payments.component.html',
  styleUrls: ['./payments.component.scss'],
})
export class PaymentsComponent implements OnInit {
  paymentForm: UntypedFormGroup = null;
  payment: any = null;
  constructor(
    public formBuilder: UntypedFormBuilder,
    public commonService: CommonService,
    private apiListService: ApilistService
  ) {
    this.paymentForm = formBuilder.group({
      admission_fees: [
        '',
        Validators.compose([Validators.required, Validators.nullValidator]),
      ],
      application_fees: [
        '',
        Validators.compose([Validators.required, Validators.nullValidator]),
      ],
    });
  }

  ngOnInit(): void {
    this.getPaymentSettings();
  }

  async getPaymentSettings() {
    let service = this.apiListService.getApiConfigs('paymenttype');
    this.payment = await this.commonService.invokeService(
      service[0].method,
      service[0].path,
      null
    );
    this.payment = this.payment?.data;
    this.getPaymentDetails();

    this.payment = this.payment.map((item) => {
      item['edit'] = false;
      return item;
    });
  }

  async updatePaymentSettings(p: any) {
    console.log('----- >>', p);

    let service = this.apiListService.getApiConfigs('updatepaymenttype');

    await this.commonService.invokeService(service[0].method, service[0].path, {
      id: p.id,
      admission_fees: p.admission_fees,
      application_fees: p.application_fees,
    });

    this.getPaymentSettings();
  }

  paymentDetails: any = null;

  search: any = {
    user_contactnumber: '',
  };

  tableColums: string[] = null;
  async getPaymentDetails() {
    let service = this.apiListService.getApiConfigs('payment');

    this.paymentDetails = await this.commonService.invokeService(
      service[0].method,
      `${service[0].path}?${queryString.stringify(this.search)}`,
      null
    );

    this.paymentDetails = this.paymentDetails.data;

    this.paymentDetails.map((item) => {
      item['paid_date'] = moment(item['paid_date']).format(
        'DD-MM-YYYY HH:mm:ss'
      );
    });

    this.tableColums = Object.keys(this.paymentDetails[0]);

    this.tableColums.splice(this.tableColums.indexOf('user_id'), 1);

    this.tableColums.splice(this.tableColums.indexOf('application_id'), 1);
  }

  downloadInvoice(data) {
    // console.log("Data", data.user_id, data.id);
    // let url = 'https://demo.emeetify.com:81/downloaduseradmissionform?user_id=${data.user_id}&id=${data.id}';
    let url =
      'https://smscap.in/api/downloadinvoice?receipt_id=' + data.receipt_id;
    // console.log(url);
    window.open(url);

    // this.commonservice.getMethod(`downloaduseradmissionform?user_id=${data.user_id}&id=${data.id}`, '')
    //   .then((resp: any) => {
    //     console.log("resp", resp);
    //     // this.downLoadFile(resp, "application/ms-excel");
    //   });
  }
}
